import { ids } from "@icarros/theme-react";
import { hexToRgba } from "@icarros/utils-react";
import styled, { css } from "styled-components";
import { Contrast } from "../../types/general.types";
import { DividerSizes, DividerVariants, DividerWeights, } from "./constants";
const { color, opacity, size } = ids || {};
const neutralSoft = css `
  border-color: ${color.border.ids_color_border_soft};
`;
const neutralMedium = css `
  border-color: ${color.border.ids_color_border_medium};
`;
const neutralStrong = css `
  border-color: ${color.border.ids_color_border_strong};
`;
const neutralOnLightSoft = css `
  border-color: ${hexToRgba(color.contrast.ids_color_contrast_onLight, opacity.ids_opacity_soft)};
`;
const neutralOnLightMedium = css `
  border-color: ${hexToRgba(color.contrast.ids_color_contrast_onLight, opacity.ids_opacity_medium)};
`;
const neutralOnLightStrong = css `
  border-color: ${hexToRgba(color.contrast.ids_color_contrast_onLight, opacity.ids_opacity_strong)};
`;
const neutralOnDarkSoft = css `
  border-color: ${hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_soft)};
`;
const neutralOnDarkMedium = css `
  border-color: ${hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_medium)};
`;
const neutralOnDarkStrong = css `
  border-color: ${hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_strong)};
`;
const primaryMedium = css `
  border-color: ${color.action.primary.ids_color_action_primary_base};
`;
const primaryStrong = css `
  border-color: ${color.action.primary.ids_color_action_primary_variant};
`;
const errorMedium = css `
  border-color: ${color.feedbacks.ids_color_feedback_error};
`;
const light = css `
  border-width: ${size.border_width.ids_size_border_small};
`;
const regular = css `
  border-width: ${size.border_width.ids_size_border_medium};
`;
const bold = css `
  border-width: ${size.border_width.ids_size_border_large};
`;
const neutral = (size, contrast) => {
    switch (size) {
        case DividerSizes.soft: {
            if (contrast === Contrast.dark)
                return neutralOnDarkSoft;
            if (contrast === Contrast.light)
                return neutralOnLightSoft;
            return neutralSoft;
        }
        case DividerSizes.medium: {
            if (contrast === Contrast.dark)
                return neutralOnDarkMedium;
            if (contrast === Contrast.light)
                return neutralOnLightMedium;
            return neutralMedium;
        }
        case DividerSizes.strong: {
            if (contrast === Contrast.dark)
                return neutralOnDarkStrong;
            if (contrast === Contrast.light)
                return neutralOnLightStrong;
            return neutralStrong;
        }
        default:
            return neutralSoft;
    }
};
const primary = (size) => {
    switch (size) {
        case DividerSizes.medium:
            return primaryMedium;
        case DividerSizes.strong:
            return primaryStrong;
        default:
            return primaryMedium;
    }
};
const error = (size) => {
    switch (size) {
        case DividerSizes.medium:
            return errorMedium;
        default:
            return errorMedium;
    }
};
const getDividerWeightStyle = (weight) => {
    switch (weight) {
        case DividerWeights.light:
            return light;
        case DividerWeights.regular:
            return regular;
        case DividerWeights.bold:
            return bold;
        default:
            return regular;
    }
};
const getDividerKindSizeStyle = (variant, size, contrast) => {
    switch (variant) {
        case DividerVariants.neutral:
            return neutral(size, contrast);
        case DividerVariants.error:
            return error(size);
        case DividerVariants.primary:
            return primary(size);
        default:
            return neutral(size, contrast);
    }
};
const StyledDivider = styled.div `
  display: block;
  width: 100%;
  border-bottom: ${size.border_width.ids_size_border_small} solid;
  ${({ weight }) => getDividerWeightStyle(weight)};
  ${({ variant, size, contrast }) => getDividerKindSizeStyle(variant, size, contrast)};
`;
export default StyledDivider;
//# sourceMappingURL=Divider.style.js.map